import {
    Button,
    Container,
    Col,
    createStyles,
    Grid,
    Text,
    Textarea,
    TextInput,
    Title, Box,
} from "@mantine/core";
import { Rater } from "./Rater";
import React from "react";

const useStyles = createStyles((theme) => ({
    grid: {
        minWidth: '76.25em',
    },
    gridText: {
        fontSize: '1rem',
    },
    comment: {
        paddingLeft: "1.75em",
        margin: 0,
        padding: 0,
        fontWeight: 650,
    },
    step: {
        flex: 1,
        textAlign: 'center',
    },
    row: {
        borderBottom: `1px solid ${theme.colors.gray[3]}`,
        paddingBottom: theme.spacing.xs,
        marginBottom: theme.spacing.xs,
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        height: '100%',
    },
    button: {
        margin: `0.125em 0`,
    },
    scoreContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    dataRow: {
        height: '2em',
    },
    header: {
        fontWeight: 650,
    },
}));

interface Data {
    id: string;
    name: string;
    steps: string[];
}

interface RatePageProps {
    setScore: (id: string, value: number) => void;
    data: Data[];
    totalScore: number;
    maxScore: number;
    next: () => void;
    setComment: (id: string, value: string) => void;
    setTraineeId: (id: string) => void;
    traineeId: string;
    scores: Record<string, number>;
    comments: Record<string, string>;
    leave: () => void;
    updateElapsedTime?: () => void;
    updateTimerStatus?: () => void;
    disableInput: boolean;
}

// ToDo: We must localize strings here and other places
export const RatePage: React.FC<RatePageProps> = ({
                                                      setScore,
                                                      data,
                                                      totalScore,
                                                      maxScore,
                                                      next,
                                                      setComment,
                                                      setTraineeId,
                                                      traineeId,
                                                      scores,
                                                      comments,
                                                      leave,
                                                      updateElapsedTime,
                                                      updateTimerStatus,
                                                      disableInput,
                                                  }) => {
    const { classes } = useStyles();

    return (
        <div>
            <form onSubmit={next}>
                <Container>
                    <Grid gutter={0} className={`${classes.grid} ${classes.row}`} columns={20}>
                        <Col span={16}>
                            <Grid gutter={0} columns={24}>
                                <Col span={4}>
                                    <Grid gutter={0} columns={8}>
                                        <Col span={7}>
                                            <Text color="orange" className={classes.header}>PARAMETER</Text>
                                        </Col>
                                        <Col span={1}>
                                            <Text color="orange" className={classes.header}>SCORE</Text>
                                        </Col>
                                    </Grid>
                                </Col>
                                <Col span={1}/>
                                <Col span={19}>
                                    <Grid gutter={0} columns={20}>
                                        <Col span={20} style={{ display: 'flex', justifyContent: 'space-between', padding: '0 1.2em 0 0.5em' }}>
                                            {[1, 2, 3, 4, 5].map((num) => (
                                                <Text color="orange" key={num} className={classes.header}>{num}</Text>
                                            ))}
                                        </Col>
                                    </Grid>
                                </Col>
                            </Grid>
                        </Col>
                        <Col span={2}/>
                        <Col span={2}>
                            <Text color="orange" className={classes.comment}>COMMENTS</Text>
                        </Col>
                    </Grid>
                    {data.map((row, index) => (
                        <Grid gutter="xs" className={classes.grid} key={index} columns={20}>
                            <Col span={18} className={classes.row}>
                                <Grid gutter="xs" columns={27} >
                                    <Col span={5} className={classes.dataRow}>
                                        <Title order={6}>{row.name}</Title>
                                    </Col>
                                    <Col span={19}>
                                        <Rater
                                            disabled={disableInput}
                                            key={row.id}
                                            steps={row.steps}
                                            id={row.id}
                                            onClick={setScore}
                                            initialValue={isNaN(scores[row.id]) ? -1 : scores[row.id]}
                                        />
                                    </Col>
                                    <Col span={3}/>
                                    <Col span={27}>
                                        <Grid gutter={0} columns={24}>
                                            <Col span={2}/>
                                            <Col span={21}>
                                                <Grid  columns={24}>
                                                    <Col span={7}>
                                                        <Box className={classes.step}>{row.steps[0]}</Box>
                                                    </Col>
                                                    <Col span={3} />
                                                    <Col span={5}>
                                                        <Box className={classes.step}>{row.steps[2]}</Box>
                                                    </Col>
                                                    <Col span={4} />
                                                    <Col span={5}>
                                                        <Box className={classes.step}>{row.steps[4]}</Box>
                                                    </Col>
                                                </Grid>
                                            </Col>
                                            <Col span={1}/>
                                        </Grid>
                                    </Col>
                                </Grid>
                            </Col>
                            <Col span={2} className={classes.row}>
                                <Textarea
                                    autosize
                                    minRows={4}
                                    key={row.name}
                                    id={row.name}
                                    style={{ padding: '0.3125em' }}
                                    onChange={(event) => {
                                        setComment(row.id, event.target.value);
                                    }}
                                    defaultValue={comments[row.name]}
                                />
                            </Col>
                        </Grid>
                    ))}
                    <Grid gutter="xs" className={classes.grid} columns={20}>
                        <Col span={16}>
                            <Grid gutter="xs" columns={24} className={classes.scoreContainer}>
                                <Col span={5}>
                                    <Title order={5}>
                                        Total: {totalScore}/{maxScore}
                                    </Title>
                                </Col>
                                <Col span={19} >
                                        <TextInput
                                            key="Trainee ID"
                                            id="Trainee ID"
                                            onChange={(event) => {
                                                setTraineeId(event.target.value);
                                            }}
                                            label="Trainee ID"
                                            required
                                            defaultValue={traineeId}
                                        />
                                </Col>
                            </Grid>
                        </Col>
                        <Col span={2} className={classes.buttonContainer}>
                            <Button className={classes.button} color="orange" onClick={leave}>
                                BACK
                            </Button>
                            <Button className={classes.button} color="orange" type="submit">
                                NEXT
                            </Button>
                        </Col>
                    </Grid>
                </Container>
            </form>
        </div>
    );
};